import { createTheme } from "@mui/material/styles";
import { commonStyles } from "./components/common/commonStyles";

// Global CMP MUI theme (shared dashboard consistency pass, SH-001/SH-002).
//
// Before this theme existed there was no ThemeProvider at all, so every MUI
// control without a local `sx` rendered the MUI default blue (#1976d2) for
// checked/focused states — the root cause of the scattered "blue instead of
// gold" review issues. Do not remove this provider; prefer relying on it over
// re-adding per-field focus/checked sx.
//
// Brand rules (defect ledger + polish-pass answers):
// - Focus/selected field states and radios: CMP gold (#E1A731) — SH-002/CS-004.
// - Selected checkbox checkmarks: CMP gold — Q-008 (Moeen, July 2, 2026)
//   supersedes SH-001's green checkboxes platform-wide.
// - Switches and success states stay green (cmpGreen).
// - Errors/required asterisks: red.
const CMP_GOLD = commonStyles.cpaGold;
const CMP_GREEN = commonStyles.cmpGreen;
const CMP_ERROR_RED = commonStyles.errorRed;

export const cmpTheme = createTheme({
  palette: {
    primary: {
      main: CMP_GOLD,
      contrastText: "#FFFFFF",
    },
    success: {
      main: CMP_GREEN,
    },
    error: {
      main: CMP_ERROR_RED,
    },
  },
  components: {
    // Gold checkmarks everywhere a checkbox is selected — Q-008 (Moeen,
    // July 2, 2026) supersedes SH-001's green. primary.main IS cpaGold.
    // Local color one-offs should be removed rather than overriding this.
    MuiCheckbox: {
      defaultProps: {
        color: "primary",
      },
    },
    // Radios use the gold selected state (CS-004/EVT-GLOBAL-003).
    MuiRadio: {
      defaultProps: {
        color: "primary",
      },
    },
    // Switches are green when on, matching the settings toggles.
    MuiSwitch: {
      defaultProps: {
        color: "success",
      },
    },
    // Gold focus ring/border for outlined inputs that have no local sx.
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: CMP_GOLD,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: CMP_GOLD,
          },
        },
      },
    },
  },
});
